import React from "react";
import { Dialog, AppBar, Toolbar, IconButton, Typography, Box, Chip } from "@mui/material";
import { Close } from "@mui/icons-material";

export default function CategoryPickerModal({ open, onClose, categories, value, onSelect }) {
  const pick = (v) => {
    onSelect(v);
    onClose();
  };

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <AppBar position="sticky" color="default" elevation={0} sx={{ bgcolor: "#fff", borderBottom: "1px solid", borderColor: "divider" }}>
        <Toolbar>
          <Typography variant="h6" fontWeight={800} sx={{ flex: 1 }}>
            Select Category
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
        <Chip
          label="All Categories"
          onClick={() => pick("all")}
          color={value === "all" ? "primary" : "default"}
          variant={value === "all" ? "filled" : "outlined"}
          sx={{ fontWeight: 600 }}
        />
        {categories.map((c) => (
          <Chip
            key={c.id}
            label={c.name}
            onClick={() => pick(c.id)}
            color={value === c.id ? "primary" : "default"}
            variant={value === c.id ? "filled" : "outlined"}
            sx={{ fontWeight: 600 }}
          />
        ))}
      </Box>
    </Dialog>
  );
}
